import { descending } from 'd3';

export const LOAD_HISTORY = 'load_history';

export default (dispatch, getState) => {
  dispatch({ type: LOAD_HISTORY, data: 'Loading saved portfolios from DPD...' });

  const { params } = getState();

  const url = `${process.env.REACT_APP_DPD_URL}/api/portfolio/find_overview/`;

  // If not signed in, the token will be defined so skip loading
  if (params.token !== 'undefined') {

  fetch(`${url}?clientEmail=${params.clientEmail}&wtRegion=${params.wtRegion}`, { 
    headers: {
      Authorization: params.token &&
        `Token ${params.token}`,
    },
  })
    .then(d => {
      if(d.status === 404){
        dispatch({ type: LOAD_HISTORY, data: [] })
      }
      return d.json()
    })
    .then(data => {
      const sortedData = [...data]
        .filter(p => !!p.holdings)
        .sort(
          (a, b) =>
            descending(a.favorite, b.favorite) ||
            descending(new Date(a.runDate), new Date(b.runDate))
        );
      dispatch({ type: LOAD_HISTORY, data: sortedData });
    })
    .catch(error => {
      console.error(error);
      dispatch({
        type: LOAD_HISTORY,
        data: 'Failed to load saved portfolios',
      });
    });
  }
  // If token isn't valid then don't load anything
  else {
    dispatch({ type: LOAD_HISTORY, data: [] })
  }
};



// WEBPACK FOOTER //
// ./src/actions/list-portfolios.js